import { InstructionPdfForm } from '@/features/ap_payees/components/DocInstructionMenu/types';
import { useTranslation } from '@/i18n';
import { FormCheckbox } from '@moneyforward/ap-frontend-components';
import { FC, memo } from 'react';
import { Control } from 'react-hook-form';
import styles from './styles.module.scss';

export type TInstructionTemplateProps = {
  control: Control<InstructionPdfForm>;
};

export const InstructionTemplate: FC<TInstructionTemplateProps> = memo(
  ({ control }) => {
    const { t } = useTranslation();

    return (
      <div className={styles['instruction-template']}>
        <FormCheckbox<InstructionPdfForm>
          name='saveAsTemplate'
          control={control}
          label={t('export_instruction_pdf_save_as_template')}
          inputId='saveAsTemplate'
        />
      </div>
    );
  }
);

InstructionTemplate.displayName = 'InstructionTemplate';
